import zustand from 'zustand';


export const indicesPreguntasContestadasStore = zustand(set => ({
    indicesPreguntasContestadas: [],
    agregarIndice: (indice) => { 
        set(state => state.indicesPreguntasContestadas.push(indice))
    },
    vaciarArreglo: () => {
        set(state => state.indicesPreguntasContestadas.length = 0)
    }
}))


export const indicesPreguntasMateriaStore = zustand(set => ({
    indicesPreguntasMateria: [],
    agregarIndices: (indices) => {
        set(state => state.indicesPreguntasMateria.push(indices))
    },
    vaciarArreglo: () => {
        set(state => state.indicesPreguntasMateria.length = 0)
    }
}))